import { createFileRoute } from '@tanstack/react-router';

import { UpcomingScreen } from '../../features/upcoming/upcoming-screen';

/**
 * `/mylab/upcoming` — S13 학회 탐색 (E14 §2)
 *
 * 라우트는 얇게 둔다: 화면은 `features/upcoming`에 있다. 게이트는 부모 `mylab.tsx`가 맡는다.
 *
 * `eventId`는 S6 캘린더의 마감 일정이 보내는 값이다(S0 §8.1 search param 기반 인접 상세).
 * 목록이 커서 페이지네이션이라 그 학회가 첫 페이지에 없을 수 있어, 화면이 따로 불러와
 * 맨 위에 고정한다 — 없으면 캘린더에서 넘어온 사용자가 도착하지 못한다.
 */
export const Route = createFileRoute('/mylab/upcoming')({
  component: UpcomingScreen,
  validateSearch: (search: Record<string, unknown>): { eventId?: string } => ({
    eventId: typeof search.eventId === 'string' && search.eventId ? search.eventId : undefined,
  }),
});
